import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { v4 } from 'uuid';
import { fetchRenewalInfo } from './billing-data.actions';

@Injectable()
export class BillingDataDispatcher {
  constructor(private _store: Store<any>) {}

  fetchRenewalInfo() {
    const dispatchId = v4();

    this._store.dispatch(fetchRenewalInfo(dispatchId));
  }
}
